(() => {
  const root = (window.KOMModules = window.KOMModules || {});

  root.setupCookieConsent = () => {
    const storageKey = 'kom_cmp_consent_v1';
    const cookieName = 'kom_cmp_consent_v1';
    const banner = document.querySelector('[data-cmp-banner]');
    const modal = document.querySelector('[data-cmp-modal]');
    const openButtons = Array.from(document.querySelectorAll('[data-cmp-open]'));
    const openPanelButtons = Array.from(document.querySelectorAll('[data-cmp-open-panel]'));
    const closeButtons = Array.from(document.querySelectorAll('[data-cmp-close]'));
    const rejectButtons = Array.from(document.querySelectorAll('[data-cmp-reject]'));
    const acceptButtons = Array.from(document.querySelectorAll('[data-cmp-accept]'));
    const saveButtons = Array.from(document.querySelectorAll('[data-cmp-save]'));
    const fieldNodes = {
      analytics: document.querySelector('[data-cmp-field="analytics"]'),
      preferences: document.querySelector('[data-cmp-field="preferences"]'),
      marketing: document.querySelector('[data-cmp-field="marketing"]'),
    };

    if (!banner || !modal) {
      return;
    }

    let memoryConsent = null;

    const setLockState = (locked) => {
      document.body.classList.toggle('cmp-banner-open', locked);
      document.body.classList.toggle('cmp-modal-open', locked && !modal.hidden);
      document.documentElement.classList.toggle('cmp-banner-open', locked);
      document.documentElement.classList.toggle('cmp-modal-open', locked && !modal.hidden);
    };

    const safeParse = (raw) => {
      try {
        return JSON.parse(raw);
      } catch (error) {
        return null;
      }
    };

    const readCookie = (name) => {
      const escaped = name.replace(/([.$?*|{}()\[\]\\/+^])/g, '\\$1');
      const match = document.cookie.match(new RegExp(`(?:^|; )${escaped}=([^;]*)`));
      return match ? decodeURIComponent(match[1]) : '';
    };

    const writeCookie = (name, value, maxAgeDays) => {
      const maxAge = Math.max(1, Number(maxAgeDays || 180)) * 24 * 60 * 60;
      const secure = window.location.protocol === 'https:' ? '; Secure' : '';
      document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAge}; SameSite=Lax${secure}`;
    };

    const createConsent = (choices, source) => ({
      version: 1,
      source,
      updatedAt: new Date().toISOString(),
      choices: {
        necessary: true,
        analytics: Boolean(choices.analytics),
        preferences: Boolean(choices.preferences),
        marketing: Boolean(choices.marketing),
      },
    });

    const readConsent = () => {
      const cookieRaw = readCookie(cookieName);
      if (cookieRaw) {
        const cookieParsed = safeParse(cookieRaw);
        if (cookieParsed && typeof cookieParsed === 'object' && cookieParsed.choices) {
          return createConsent(cookieParsed.choices, cookieParsed.source || 'saved-cookie');
        }
      }

      // Fuente de verdad: cookie. Si no existe, el usuario debe volver a elegir.
      return null;
    };

    const readLegacyLocalStorageConsent = () => {
      let raw = null;
      try {
        raw = window.localStorage.getItem(storageKey);
      } catch (error) {
        return memoryConsent;
      }

      if (!raw) {
        return memoryConsent;
      }

      const parsed = safeParse(raw);
      if (!parsed || typeof parsed !== 'object' || !parsed.choices) {
        return null;
      }

      return createConsent(parsed.choices, parsed.source || 'saved');
    };

    const dispatchConsent = (consent) => {
      const detail = {
        consent,
        granted: {
          analytics: consent.choices.analytics,
          preferences: consent.choices.preferences,
          marketing: consent.choices.marketing,
        },
      };

      document.documentElement.setAttribute('data-cmp-analytics', detail.granted.analytics ? 'granted' : 'denied');
      document.documentElement.setAttribute('data-cmp-preferences', detail.granted.preferences ? 'granted' : 'denied');
      document.documentElement.setAttribute('data-cmp-marketing', detail.granted.marketing ? 'granted' : 'denied');
      window.dispatchEvent(new CustomEvent('cmp:consent-changed', { detail }));
    };

    const persistConsent = (consent) => {
      memoryConsent = consent;

      // Cierra primero para no bloquear al usuario aunque algo falle en tracking/storage.
      banner.hidden = true;
      modal.hidden = true;
      document.body.classList.remove('cmp-modal-open');
      document.body.classList.remove('cmp-banner-open');
      document.documentElement.classList.remove('cmp-modal-open');
      document.documentElement.classList.remove('cmp-banner-open');
      setLockState(false);

      try {
        writeCookie(cookieName, JSON.stringify(consent), 180);
      } catch (error) {
        // Si falla la cookie, intentamos conservar al menos en memoria/localStorage.
      }

      try {
        window.localStorage.setItem(storageKey, JSON.stringify(consent));
      } catch (error) {
        // Fallback en memoria si el navegador bloquea storage.
      }

      try {
        dispatchConsent(consent);
      } catch (error) {
        // Evita que errores de terceros impidan navegar.
      }
    };

    const setFormFromConsent = (consent) => {
      if (fieldNodes.analytics) {
        fieldNodes.analytics.checked = Boolean(consent?.choices?.analytics);
      }

      if (fieldNodes.preferences) {
        fieldNodes.preferences.checked = Boolean(consent?.choices?.preferences);
      }

      if (fieldNodes.marketing) {
        fieldNodes.marketing.checked = Boolean(consent?.choices?.marketing);
      }
    };

    const openModal = () => {
      modal.hidden = false;
      document.body.classList.add('cmp-modal-open');
      document.documentElement.classList.add('cmp-modal-open');
      setLockState(true);
    };

    const closeModal = () => {
      modal.hidden = true;
      document.body.classList.remove('cmp-modal-open');
      document.documentElement.classList.remove('cmp-modal-open');
      setLockState(!banner.hidden);
    };

    const onReject = () => {
      persistConsent(createConsent({ analytics: false, preferences: false, marketing: false }, 'reject-all'));
    };

    const onAccept = () => {
      persistConsent(createConsent({ analytics: true, preferences: true, marketing: true }, 'accept-all'));
    };

    const onSave = () => {
      persistConsent(
        createConsent(
          {
            analytics: Boolean(fieldNodes.analytics?.checked),
            preferences: Boolean(fieldNodes.preferences?.checked),
            marketing: Boolean(fieldNodes.marketing?.checked),
          },
          'custom'
        )
      );
    };

    openButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const current = readConsent();
        setFormFromConsent(current);
        openModal();
      });
    });

    openPanelButtons.forEach((button) => {
      button.addEventListener('click', openModal);
    });

    closeButtons.forEach((button) => {
      button.addEventListener('click', closeModal);
    });

    rejectButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        onReject();
      });
    });

    acceptButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        onAccept();
      });
    });

    saveButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        onSave();
      });
    });

    // Fallback por delegacion para asegurar accion en botones dinamicos o listeners perdidos.
    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target.closest('[data-cmp-accept],[data-cmp-reject],[data-cmp-save]') : null;
      if (!target) {
        return;
      }

      if (target.hasAttribute('data-cmp-accept')) {
        event.preventDefault();
        onAccept();
        return;
      }

      if (target.hasAttribute('data-cmp-reject')) {
        event.preventDefault();
        onReject();
        return;
      }

      if (target.hasAttribute('data-cmp-save')) {
        event.preventDefault();
        onSave();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !modal.hidden) {
        closeModal();
      }
    });

    const existingConsent = readConsent();
    if (existingConsent) {
      dispatchConsent(existingConsent);
      banner.hidden = true;
      setFormFromConsent(existingConsent);
      setLockState(false);
      return;
    }

    // Si viene de versiones antiguas con solo localStorage, forzamos nueva eleccion
    // para alinear comportamiento con la limpieza de cookies del navegador.
    const legacyConsent = readLegacyLocalStorageConsent();
    if (legacyConsent) {
      try {
        window.localStorage.removeItem(storageKey);
      } catch (error) {
        // Ignorar.
      }
    }

    banner.hidden = false;
    document.body.classList.add('cmp-banner-open');
    document.documentElement.classList.add('cmp-banner-open');
    setLockState(true);
    setFormFromConsent(createConsent({ analytics: false, preferences: false, marketing: false }, 'default'));
  };
})();
